import { render } from "./WeBuiltADemo.vue?vue&type=template&id=66429055&scoped=true"
import script from "./WeBuiltADemo.vue?vue&type=script&lang=js"
export * from "./WeBuiltADemo.vue?vue&type=script&lang=js"

import "./WeBuiltADemo.vue?vue&type=style&index=0&id=66429055&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/simple-city-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66429055"]])

export default __exports__